enum APP_CONSTANTS {
  DEEPLINK_URL = 'xero-touch://login',
  ERROR_LOGO_URL = 'https://edge.xero.com/illustration/robot-and-person-looking-in-a-box-01/robot-and-person-looking-in-a-box-01.svg',
  XERO_HELP_CENTRAL_400_500_URL = 'https://central.xero.com/s/article/Error-message-404-and-500-in-Xero'
}

export default APP_CONSTANTS;
